export default __webpack_public_path__ + "static/media/wa_4.07329bee.mp3";